import React from 'react';
import styles from './Performance.module.css';

interface AH03Component extends React.FC {
  title?: string;
}

const AH03: AH03Component = () => {
  return (
    <div>
      <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Metric Description</div>
          <p>
            AOS In-Stock Accuracy is used to ensure that the inventory feed your store is providing to acehardware.com is as accurate as possible and to ensure there is not an inventory accuracy issue occurring. This metric is calculated at the item level by dividing the total number of declined items by the total number of purchased items.
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Supporting Details</div>
          <p>
            Find more information here:{' '}
            <a 
              href="https://acenet.aceservices.com/my-store" 
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Manage My Store
            </a>
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Goal</div>
          <p>
            94% (all In-Store pick orders should be in-stock)
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Update Cadence</div>
          <p>
            Metric is current state and updated monthly.
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Learn More</div>
          <p>
            Review this rate to measure your inventory feed&apos;s accuracy to acehardware.com.
            <br/>
            For additional guidance review the {' '}
            <a 
              href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ace Way of Retailing acehardware.com fulfillment Store Procedures
            </a>
          </p>
      </div>
    </div>
  );
};

AH03.title = 'AOS In-Stock Accuracy';
export default AH03;
